import React from "react";
import { RouteProps, Link } from "react-router-dom";
import { ISales } from "../../../services/api/Sales";
import Button from "../../../components/Form/Button";
import ItemBox from "../../../components/ItemBox";

interface GroupListProps extends RouteProps {
  data: ISales[];
  year: Number;
  month: Number;
}

const GroupList: React.FC<GroupListProps> = ({ data, year, month }) => {
  function renderRow(sales: ISales) {
    return (
      <li key={sales.groupId}>
        <ItemBox
          {...(sales.children ? { className: "hasChildren" } : null)}
          name={sales.groupName + " - " + sales.groupCode}
        >
          {sales.groupParentId ? (
            <Link
              to={"/sales-update/" + sales.groupId + "/" + year + "/" + month}
            >
              <Button className="box__edit" title="Details" />
            </Link>
          ) : null}
        </ItemBox>

        {sales.children ? (
          <ul className="groups__list"> {sales.children.map(renderRow)}</ul>
        ) : null}
      </li>
    );
  }

  return (
    <React.Fragment>
      <ul className="groups__list groups__list--main">{data.map(renderRow)}</ul>
    </React.Fragment>
  );
};

export default GroupList;
